import { axios_form, Axios } from './resource'
import {JSEncrypt} from 'jsencrypt'
import md5 from 'md5'
const securityKey = 'e1996c7d6e0ff0664b28af93a2eeff8f8cae84b2402d158f7bb115b735a1663d'
function encryption (password, token) {
  var content = md5(password) + (token || '')
  var publickey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCVhaR3Or7suUlwHUl2Ly36uVmboZ3+HhovogDjLgRE9CbaUokS2eqGaVFfbxAUxFThNDuXq/fBD+SdUgppmcZrIw4HMMP4AtE2qJJQH/KxPWmbXH7Lv+9CisNtPYOlvWJ/GHRqf9x3TBKjjeJ2CjuVxlPBDX63+Ecil2JR9klVawIDAQAB"
  var encrypt = new JSEncrypt()
  encrypt.setPublicKey(publickey)
  encrypt.getPublicKey()
  var encrypted = encrypt.encrypt(content)
  return encrypted
}
let mobileSMSCodeURL = '/passport/v1/sms/send'
let mobileSMSCodeVerifyURL = '/passport/v1/phone/validate'
let Api = {
  checkAccount: params => 
    Api.getLoginToken()
      .then(res => {
        let { token } = res.data
        return token
      })
      .then(token => {
        let beforMd5 = ''
        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            beforMd5 += `${key}=${params[key]}&`
          }
        }
        beforMd5 += `nonce=${token}&${securityKey}`
        let signature = md5(beforMd5.toLowerCase())
        let paramsData = { ...params, nonce: token, signature: signature }
        return axios_form.post(`/passport/login/checkAccount`, paramsData)
      }), 
  getLoginToken: () => Axios.get(`/passport/token/login`),
  getQrCode (size='L') {
      return Axios.get(`/passport/qrcode/gen?level=${size}`)
  },
  checkQr: param => Axios.get(`/passport/qrcode/check/${param}`),
  submit (params, callback) {
    var p = this.getLoginToken().then(res => {
      if (res.data.ret === 0) {
        return res.data.token
      } else {
        throw new Error('系统出错了！')
      }
    }).catch(e => {
      throw new Error('系统出错了！')
    })
    return p.then(token => {
      params.password = encryption(params.password, token)
      return axios_form.post(`/passport/v4/security/popupLogin`, params)
    })
  },
  smsSend (params) {
    var p = this.getLoginToken().then(res => {
      if (res.data.ret === 0) {
        return res.data.token
      } else {
        throw new Error('系统出错了！')
      }
    }).catch(e => {
      throw new Error('系统出错了！')
    })
    return p.then(token => {
      params.nonce = token
      return axios_form.post(`/passport/v1/sms/send`, params)
    })
  },
  smsVerifyBind (params) {
    var p = this.getLoginToken().then(res => {
      if (res.data.ret === 0) {
        return res.data.token
      } else {
        throw new Error('系统出错了！')
      }
    }).catch(e => {
      throw new Error('系统出错了！')
    })
    return p.then(token => {
      params.nonce = token
      return axios_form.post(`/passport/v1/sms/verifyBind`, params)
    })
  },
  getMobileSMSCode ({
    phone: phone_num,
    sendType = 1,
    msgType = 32
  } = {} ) {
    let p = this.getLoginToken().then(res => {
      if (res.data.ret === 0) {
        return res.data.token
      } else {
        throw new Error('系统出错了！')
      }
    }).catch(e => {
      throw new Error('系统出错了！')
    })
    return p.then(nonce => {
      return axios_form.post(mobileSMSCodeURL, { phone_num, sendType, msgType, nonce })
    })
  },
  checkMobileSMSCode ({
    phone_num,
    smsCode,
    checkKey
  } = {}) {
    let p = this.getLoginToken().then(res => {
      if (res.data.ret === 0) {
        return res.data.token
      } else {
        throw new Error('系统出错了！')
      }
    }).catch(e => {
      throw new Error('系统出错了！')
    })
    return p.then(nonce => {
      return axios_form.post(mobileSMSCodeVerifyURL, { phone_num, smsCode, checkKey, nonce })
    })
  },
  getImageCodeInfo({
    info
  } = {}) {
    return Axios.get('/xmcaptcha-service/getCaptcha/ts-123', { params: { info } })
  },
  checkImageCode({
    token,
    checkCode
  }) {
    return Axios.get('/xmcaptcha-service/checkCaptcha/ts-123', { params: { token, checkCode } })
  }
}

export default Api


// WEBPACK FOOTER //
// ./src/api/index.js